import { Component, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { ApiService } from '../api.service';
import { AppComponent } from '../app.component';
import { AuthService } from '../auth.service';
import { BottomSheet } from '../bottom.sheet';
import { HandlerService } from '../handler.service';

@Component({
  selector: 'app-billings',
  templateUrl: './billings.component.html',
  styleUrls: ['./billings.component.scss'],
})
export class BillingsComponent{
  bill:boolean;
  id;
  url;
  billingConfig: any = [];
  comType = [
    { name: "Percentage Commission", id: '1' },
    { name: "Standard Fee Per Customer", id: '3' }
  ]
  comname = 'Percentage Commission';
  orgIdS = parseInt(localStorage.getItem('organizationId'));
  orgId = localStorage.getItem('organizationId');
  readsp:boolean = true;
  comId;
  loader:boolean = false;
  userObj;
  cost;
  constructor(public service: ApiService,
    public router: Router,
    public handler: HandlerService,
    public auth: AuthService,
    public app: AppComponent,
    public sanitizer: DomSanitizer,
    public bottomSheet: MatBottomSheet,
     public santinzer: DomSanitizer,
      public platform: Platform) { }

      ionViewWillEnter(){
        this.url = window.location.href;
        this.id = this.url.split('/').pop();
        this.service.getAddressById(this.id).subscribe(res => {
          this.userObj = res;
          if(this.userObj.billingConfigs){
            if(this.userObj.billingConfigs[0]){
              this.comId = this.userObj.billingConfigs[0].commissionType;
              this.cost = this.userObj.billingConfigs[0].costPerService;              
            }
          }
          setTimeout(() => {
            this.comType.map(res1 => {
              if (res1.id == this.comId) {
                this.comname = res1.name;
               }
            })
          }, 1000);
          this.loader = false;
        },err => {
          this.handler.err(err);
          this.loader = false;
        })
      }
   
      openBottomSheetCommissionType(): void {
        const dialogRef = this.bottomSheet.open(BottomSheet, {
          data: this.comType,
        });
        dialogRef.afterDismissed().subscribe((res) => {
          this.comname = res.name;
          this.comId= res.id;
        });
      }
      UpdateProfile(){
        this.loader = true;
        this.url = window.location.href;
        this.id = this.url.split('/').pop();
        this.userObj.billingConfigs[0].costPerService = this.cost;      
         this.service.postProfileDetails(this.id,this.userObj).subscribe(res=>{
           this.loader = false;
         this.handler.res('Billing Data Updated Successfully');
         this.router.navigate(['vendorProfile/',this.id])
         this.ionViewWillEnter();
        }, err => {
         this.handler.err(err);
         this.loader=false;
       })
      }
 

  back(){
    this.router.navigate(['vendorProfile/',+ this.id ])
  }
}
